import React from 'react'
import { Form } from '@pinchenterprisesnpm/friday-ui'
import { Col } from 'styled-bootstrap-grid'
import GenericTooltip from '../../GenericTooltip'
import { ColumnType, OffsetType } from '../utils'
import { Label } from './style'
const { Checkbox } = Form

type FormCheckboxProps = {
  label?: string
  name: string
  value: boolean
  handleChange: (field: string, value: any) => void
  tooltipMessage?: string
  fieldColumns?: ColumnType
  labelColumns?: ColumnType
  fieldOffset?: OffsetType
  isDisabled?: boolean
}

const FormCheckbox = (props: FormCheckboxProps) => {
  const {
    label,
    name,
    value,
    handleChange,
    tooltipMessage,
    fieldColumns,
    labelColumns,
    fieldOffset,
    isDisabled,
  } = props
  return (
    <>
      {label && (
        <Col lg={labelColumns}>
          <Label>{label}</Label>
          {tooltipMessage && <GenericTooltip message={tooltipMessage} />}
        </Col>
      )}
      <Col lg={fieldColumns} md={fieldColumns} offset={fieldOffset} mdOffset={fieldOffset}>
        <Checkbox
          name={name}
          value={value}
          onChange={(e: boolean, rest: React.ChangeEvent<HTMLInputElement>) => {
            handleChange(rest.target.name, e)
          }}
          isDisabled={isDisabled}
        />
      </Col>
    </>
  )
}

FormCheckbox.defaultProps = {
  fieldColumns: 9,
  labelColumns: 2,
  fieldOffset: 0,
  label: '',
  isDisabled: false,
}

export default FormCheckbox
